module.exports = __webpack_public_path__ + "static/media/wallet.28bcb930.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/GetAShareResources/wallet.svg
// module id = 186
// module chunks = 0